// Phase 6.3.3 (S3.3) — readable workspace-rail initials.
//
// The old "first 2 chars" approach produced unreadable badges:
// "NL2SQL - Internal" → "N-", "ARKIV 360" → "A3". This derives
// letter-based initials, skipping pure-numeric words and special
// characters.

export function getWorkspaceInitials(name: string): string {
  if (!name) return "";

  // 1. Keep only alphanumerics + spaces.
  const cleaned = name.replace(/[^a-zA-Z0-9\s]/g, "").trim();

  // 2. Split into words.
  const words = cleaned.split(/\s+/).filter(Boolean);

  // 3. Multi-word: first letters of the first two letter-bearing words.
  if (words.length > 1) {
    const letterWords = words.filter((w) => /[a-zA-Z]/.test(w));
    if (letterWords.length >= 2) {
      return (letterWords[0]![0]! + letterWords[1]![0]!).toUpperCase();
    }
    if (letterWords.length === 1) {
      const w = letterWords[0]!;
      return (w[0]! + (w[1] ?? "")).toUpperCase();
    }
  }

  // 4. Single word: first two letter chars.
  const letters = (cleaned.match(/[a-zA-Z]/g) ?? []).slice(0, 2);
  if (letters.length === 2) return letters.join("").toUpperCase();
  if (letters.length === 1) return letters[0]!.toUpperCase();

  // 5. Pure-numeric / no letters: first two chars of the original.
  return (name[0]! + (name[1] ?? "")).toUpperCase().slice(0, 2);
}
